module.exports = __webpack_public_path__ + "img/award_01.6799aad.png";